import { createContext, useContext, useState, useCallback } from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'

const ToastContext = createContext(null)

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, variant = 'success', duration = 5000) => {
    const id = Date.now() + Math.random()
    setToasts(prev => [...prev, { id, message, variant, duration }])
  }, [])

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  const showSuccess = useCallback((message) => {
    addToast(message, 'success')
  }, [addToast])

  const showError = useCallback((message) => {
    addToast(message, 'danger', 7000)
  }, [addToast])

  const showWarning = useCallback((message) => {
    addToast(message, 'warning', 6000)
  }, [addToast])

  const showInfo = useCallback((message) => {
    addToast(message, 'info')
  }, [addToast])

  const value = {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    addToast
  }

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        {toasts.map(toast => (
          <Toast
            key={toast.id}
            onClose={() => removeToast(toast.id)}
            show={true}
            delay={toast.duration}
            autohide
            bg={toast.variant}
          >
            <Toast.Header>
              <strong className="me-auto">
                {toast.variant === 'success' && 'Success'}
                {toast.variant === 'danger' && 'Error'}
                {toast.variant === 'warning' && 'Warning'}
                {toast.variant === 'info' && 'Info'}
              </strong>
            </Toast.Header>
            <Toast.Body className={toast.variant === 'danger' || toast.variant === 'success' ? 'text-white' : ''}>
              {toast.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  )
}

export function useToast() {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}

export default ToastContext
